export default "<!-- header component --> <aps-header></aps-header> <section class=columns-w> <div class=columns-inner> <div class=internal-c> <!-- main navigation component --> <aps-nav class=\"is-hidden-small showable\"></aps-nav> <article class=content-center> <!-- current ui.router state --> <div ui-view></div> </article> </div> </div> </section> <connection-status></connection-status>";


//////////////////
// WEBPACK FOOTER
// ./src/app/layout/app.tpl.html
// module id = 380
// module chunks = 0